import { palette } from './palette';

export const homeStyle = {
  /* Login - Styles */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: `unset !important`,
    },
    '& .hero-shaped__left-side': {
      flex: '0 0 50%',
      maxWidth: '50%',

      '@media(min-width: 900px) and (max-width: 1200px)': {
        flex: '0 0 50%',
        maxWidth: '50%',
      },
      '& .hero-shaped__image': {
        width: '50vw',

        '@media(min-width: 900px) and (max-width: 1200px)': {
          width: '50vw',
        },
      },
    },
  },

  '.smileobsession-container': {
    /* General Styles */
    '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
      backgroundColor: palette.primary.light,
    },
    '& .MuiSwitch-track': {
      border: `1px solid ${palette.primary.main}`,
    },
    '& .MuiSwitch-thumb': {
      background: palette.primary.main,
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      '& .hero-background': {
        objectFit: 'cover',
        '@media screen and (max-width: 900px)': {
          height: '340px',
        },
      },
      '& .section-header': {
        '@media screen and (min-width: 768px)': {
          marginTop: '60px',
        },
      },
      '& .home-hero-subtitle': {
        color: palette.secondary.main,
        fontSize: '24px',
      },
      '& .hero-section': {
        display: 'flex',
        alignItems: 'center',
        maxHeight: '550px',
        padding: '0px 12px',

        '@media(min-width: 900px)': {
          padding: '40px 40px 80px',
        },
      },
      '& .section-alternate__content': {
        '@media screen and (max-width: 900px)': {
          padding: '10px 16px !important',
        },
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
      },
      '& .player-container': {
        height: '410px !important',
      },
    },
    '& .hero-static-section-grid': {
      display: 'block',
      '& .section-header__title, .section-header__subtitle': {
        color: palette.text.primary,
      },
      '& .primary-static-button': {
        background: palette.text.primary,
        color: palette.text.highlight,
      },
      '& .hero-button-wrapper': {
        justifyContent: 'left',
      },
      '@media(max-width: 900px)': {
        '& .hero-button-wrapper': {
          justifyContent: 'center',
        },
      },
    },
    /* Benefits - Styles */
    '& .definition-Wrapper': {
      background: palette.background.light,
      '& #definition-section': {
        '& .definition-service-tile': {
          boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',
          background: palette.text.highlight,
          padding: '40px 24px',
          paddingBottom: '40px',
          margin: '8px',
        },
        '& .benefits-wrapper': {
          padding: '0 24px',

          '@media(min-width: 900px)': {
            padding: '0 48px',
          },
          '@media(min-width: 1200px)': {
            '& .definition-service-tile': {
              maxWidth: '23%',
            },
          },
          '@media(max-width: 1125px)': {
            '& .definition-service-tile': {
              maxWidth: '47%',
            },
          },
          '@media(max-width: 767px)': {
            '& .definition-service-tile': {
              maxWidth: '100%',
            },
          },
        },
        '& .section-header__title': {
          '@media(max-width: 899px)': {
            textAlign: 'left',
          },
        },
        '& .section-header__subtitle': {
          fontSize: 18,
          '@media(max-width: 899px)': {
            textAlign: 'left',
          },
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        background: palette.text.highlight,
      },
      '& #pricing-benefit-section': {
        '& .subscription-section': {
          '& .planCard': {
            border: 'none',
            boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',
            backgroundColor: palette.background.light,
            '&:hover': {
              border: `1px solid ${palette.background.light}`,
              color: palette.text.primary,
              '& .highlight-divider': {
                background: palette.divider,
              },
            },
            '@media(max-width: 900px)': {
              '& .customDisclaimerText, & .bold': {
                fontSize: '0.75rem',
              },
            },
          },
          '& .section-header': {
            maxWidth: 720,
            margin: '0px auto 32px',
          },
          '& .section-header__title, & .section-header__subtitle': {
            color: palette.secondary.main,
            '@media(max-width: 899px)': {
              textAlign: 'left',
            },
          },
        },
        '& .react-multi-carousel-list': {
          maxWidth: 1300,
        },
        '& .savings-summary-link': {
          color: palette.text.primary,
          textDecoration: 'underline',
          cursor: 'pointer',
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-wrapper': {
      padding: '10px',
      '& .howitworks-section': {
        background: 'none',
        '& .working-steps-container:not(:last-child)': {
          paddingBottom: 30,
          marginBottom: 0,
          borderBottom: `1px solid ${palette.text.disabled}`,
        },
      },
      '& .how-cover-image': {
        height: '100%',
      },
      '& .howitworks-title': {
        marginBottom: '0px',
      },
      '& .section-header__subtitle': {
        fontSize: '32px !important',
        color: palette.text.primary,
      },
      '& .howitworks-wrapper-left': {
        height: '520px',
      },
      '@media screen and (min-width: 768px)': {
        '& .working-steps-container': {
          marginBottom: '28px !important',
        },
        '& .cover-image-wrapper': {
          position: 'relative',
          top: '-72px',
        },
      },
      '@media(max-width: 900px)': {
        '& .howitworks-title': {
          marginBottom: '40px',
        },
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      '@media(min-width: 900px)': {
        padding: 72,
      },

      '& .testimonialSection': {
        padding: '40px 32px',

        '@media(min-width: 900px)': {
          padding: '40px 16px',
        },

        '& .section-header__title, & .section-header__subtitle': {
          '@media(max-width: 899px)': {
            textAlign: 'left',
          },
        },

        '& .react-multiple-carousel__arrow--left': {
          left: '25%',

          '@media(max-width: 899px)': {
            left: 0,
          },
        },
        '& .react-multiple-carousel__arrow--right': {
          right: '25%',

          '@media(max-width: 899px)': {
            right: 0,
          },
        },
      },
    },

    /* Savings Summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-header': {
        color: `${palette.text.primary} !important`,
      },
      '& .service-procedure-table': {
        borderColor: palette.text.primary,
      },
      '& .savings-contact-card': {
        background: palette.background.light,
      },
    },

    /* Static Page Hero Banners */
    '& .dashboard-hero-section, & .terms-hero-section, & .privacy-hero-section, & .hipaa-hero-section':
    {
      backgroundColor: palette.text.highlight,
    },
    '& .book-appointment-hero-section, .savings-hero-section, .find-provider-section, .plan-selection-section, .checkout-hero-section':
    {
      height: '100%',
      backgroundColor: palette.text.highlight,
      backgroundSize: 'cover',
    },
    '& .faq-hero-section': {
      height: '100%',
      backgroundColor: palette.text.highlight,
      backgroundSize: 'cover',
    },
    '& .faq-contact-wrapper': {
      background: palette.background.light,
    },
    '& .MuiTab-wrapper, .faq-link': {
      textTransform: 'none',
    },

    /* Static hero banner */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.light,
        background: `url('./images/static-hero.webp') no-repeat`,
        backgroundSize: 'cover',
      },
    },

    /* FAQ Styles */
    '& .faq-wrapper': {
      marginBottom: 0,
    },

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },

    /* Create Subscriber - Checkout flow container */
    '& .checkout-flow-container': {
      background: palette.background.light,

      '& .planCard': {
        boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',
        border: 'none',
        '&:hover': {
          border: `1px solid ${palette.background.light}`,
          color: palette.text.primary,
          backgroundColor: palette.text.highlight,
          '& .highlight-divider': {
            background: palette.divider,
          },
        },
      },
      '& .hero-static-bg': {
        backgroundColor: `${palette.text.highlight} !important`,
      },
      '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
        backgroundColor: palette.primary.light,
      },
      '& .MuiSwitch-track': {
        border: `1px solid ${palette.primary.main}`,
        background: palette.text.highlight,
      },
      '& .MuiSwitch-thumb': {
        background: palette.primary.main,
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .summary-content-root, .payment-container, .customDetailsContainer': {
        boxShadow: '2px 1px 7px rgba(0, 0, 0, 0.2)',
      },
      '& .payment-title-root': {
        marginTop: 0,
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Provider Style */
    '& .find-provider-section': {
      '& .section': {
        padding: '64px 28px !important',
      },
    },

    /* Stepper - styles */
    '& .customStepperRoot': {
      '& .MuiStepConnector-lineHorizontal': {
        borderColor: '#DED9F2',
        borderWidth: '2px',
      },
      '& .stepperIconActive': {
        color: '#231942',
        border: '1px solid #231942',
      },
      '& .stepperIconRoot': {
        color: '#231942',
        border: '1px solid #231942',
      },
      '& .stepperIconText': {
        fill: palette.text.highlight,
      },
    },
    /* Footer Disclosure */
    '& .footer-wrapper, & .footer-wrapper a': {
      backgroundColor: palette.background.light,
    },

    /*Dashboard - styles */
    '& .benefits-widget': {
      '& .MuiTableCell-head': {
        backgroundColor: `${palette.primary.light} !important`,
      },
    },
    '& .leftWrapper': {
      display: 'none !important',
    }
  },
};
